<template>
    <div class="page">
        <toolbar-system :sideIcon="sideIcon"></toolbar-system>
        <progress-system :isLoad="progress"></progress-system>
        <alertbar-system v-if="AlertbarShow != null" :alertbar="AlertbarShow"></alertbar-system>
        <v-container class="animated fadeIn" v-show="novoAvisoView">
            <v-layout align-center justify-center wrap>
                <v-flex xl12>
                    <v-card>
                        <v-card-title>
                            <h1 class="display-1 text-uppercase">Gestão de avisos</h1>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form>
                                <v-text-field v-model="aviso.titulo" color="blue" label="Título do aviso"></v-text-field>
                                <!-- <v-checkbox color="blue" label="Enviar notificação push"></v-checkbox> -->
                                <v-radio-group @click="getCursos()" v-model="destinoAviso">
                                    <v-radio color="blue" label="Geral" value="geral"></v-radio>
                                    <v-radio color="blue" label="Turma" value="turma"></v-radio>
                                </v-radio-group>
                                <v-select v-model="aviso.curso" :items="cursos" item-text="Descricao" item-value="IdCurso" :loading="loadCursos == null ? true : false" color="blue" v-show="destinoAviso == 'turma'" label="Selecione a turma"></v-select>
                                <vue-editor v-model="aviso.texto"></vue-editor>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="[novoAvisoView = false, btnAvisoEditar = null]" class="silver" large dark>
                                Cancelar
                            </v-btn>
                            <v-btn v-if="btnAvisoEditar == null" @click="cadastrarAviso()" class="blue" large dark>
                                Enviar
                            </v-btn>
                            <v-btn v-else @click="atualizarAviso(aviso.id)" class="blue" large dark>
                                Atualizar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container>
            <v-layout>
                <v-flex xl12>
                    <v-card flat>
                        <v-card-title>
                            <v-text-field color="blue" label="Pesquisar" prepend-icon="mdi mdi-database-search"></v-text-field>
                            <v-btn
                                dark
                                color="blue"
                                @click="novoAvisoView = !novoAvisoView"
                            >
                                <v-icon left>mdi mdi-plus</v-icon>Novo aviso
                            </v-btn>
                        </v-card-title>
                    <v-card-text>
                    <v-list>
                        <template v-for="aviso in avisos">
                            <v-list-tile :key="aviso.index" :id="aviso.IdAviso">
                                <v-list-tile-action>
                                    <v-chip class="chip" v-if="aviso.IdTurma == null" color="orange" outline>Geral</v-chip>
                                    <v-chip class="chip" v-else color="blue" outline>Turma</v-chip>
                                </v-list-tile-action>
                                <v-list-tile-content class="text-truncate">
                                    {{aviso.Titulo}}
                                 </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-btn @click="[editarAviso(aviso.IdAviso), novoAvisoView = true, btnAvisoEditar = true]" color="orange" dark icon>
                                        <v-icon>mdi mdi-pencil</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                                <v-list-tile-action>
                                    <v-btn @click="deleteAviso(aviso.IdAviso)" color="red" dark icon>
                                        <v-icon>mdi mdi-delete</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider :key="aviso.index"></v-divider>
                        </template>
                    </v-list>
                    </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { VueEditor } from "vue2-editor"
import ToolbarSystem from '../../../components/ToolbarSystem'
import AlertbarSystem from '../../../components/AlertbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
export default {
    components:{
        ToolbarSystem,
        VueEditor,
        AlertbarSystem,
        ProgressSystem
    },
    data () {
        return{
            sideIcon: true,
            progress: true,
            aviso:{
                curso: null,
                titulo: null,
                texto: null
            },
            destinoAviso: null,
            cursos: null,
            loadCursos: null,
            avisos: null,
            novoAvisoView: false,
            AlertbarShow: null,
            btnAvisoEditar: null
        }
    },
    methods: {
        cadastrarAviso (){
            this.axios.post('admin/aviso',
                this.aviso
            ).then(res => {
                this.novoAvisoView = false
                this.aviso.curso = null
                this.aviso.titulo = null
                this.aviso.texto = null
                this.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true
                }
                this.getAvisos()
            }).finally(() => {
                this.progress = false
            })
        },
        getCursos(){
            if(this.destinoAviso == 'geral'){
                this.aviso.curso = null
                this.axios.get('/curso').then(res => {
                    this.cursos = res.data
                }).finally(() =>{
                    this.loadCursos = false
                })
            }else{
                this.aviso.curso = null
                this.axios.get('/curso').then(res => {
                    this.cursos = res.data
                }).finally(() =>{
                    this.loadCursos = false
                })
            }
        },
        getAvisos(){
            this.axios.get('admin/aviso').then(res => {
                this.avisos = res.data.reverse()
            }).finally(() => {
                this.progress = false
            })
        },
        getAvisosSearch(){
            this.axios.get('user/aviso/').then(res => {
                this.avisos = res.data.reverse()
            }).finally(() => {
                this.progress = false
            })
        },
        deleteAviso(id){
            let com = confirm("Deseja realmente excluir esse aviso?")

            if(com){
                this.axios.delete(`admin/aviso/${id}`).then(res => {
                    this.AlertbarShow = {
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true
                    }
                    this.getAvisos()
                })
            }
        },
        atualizarAviso(id){
            this.axios.put(`admin/aviso/${id}`,
                this.aviso
            ).then(res => {
                this.novoAvisoView = false
                this.aviso.curso = null
                this.aviso.titulo = null
                this.aviso.texto = null
                this.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true
                }
                this.getAvisos()
            })
        },
        editarAviso(id){
            this.btnAvisoEditar = true
            this.avisos.map(elem => {
                if(elem.IdAviso == id){

                    if(elem.IdTurma == null){
                        this.destinoAviso = 'geral'
                        this.aviso = {
                            id: elem.IdAviso,
                            curso: null,
                            titulo: elem.Titulo,
                            texto: elem.Texto
                        }
                    }else{
                        this.getCursos()
                        this.destinoAviso = 'turma'
                        this.aviso = {
                            id: elem.IdAviso,
                            curso: elem.IdTurma,
                            titulo: elem.Titulo,
                            texto: elem.Texto
                        }
                    }
                }
            })
        }
    },
    mounted(){
        this.getAvisos()
    }
}
</script>
<style>
    .chip{
        width: 70px;
        text-align: center;
        margin: 0 5 0 0;
    }
</style>
